module.exports = __webpack_public_path__ + "img/智慧水利2.3623910e.png";